export default __webpack_public_path__ + "static/media/citation-email.af2c6b07.svg";